export interface SavedWorld {
  name: string;
  timestamp: number;
  bodies: {
    pos: { x: number; y: number };
    vel: { x: number; y: number };
    mass: number;
    color: string;
    fixed: boolean;
  }[];
  config: {
    G: number;
    softening: number;
    dt: number;
    trailLength: number;
    collisionElasticity: number;
    enableCollisions: boolean;
  };
}

const KEY = 'nbody-sandbox-saves';

function safeGet<T>(fn: () => T, fallback: T): T {
  try {
    return fn();
  } catch {
    return fallback;
  }
}

export function loadSaves(): SavedWorld[] {
  return safeGet(() => {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  }, []);
}

export function saveWorld(world: SavedWorld): void {
  safeGet(() => {
    const saves = loadSaves();
    saves.push(world);
    localStorage.setItem(KEY, JSON.stringify(saves.slice(-20)));
  }, undefined);
}

export function deleteSave(index: number): void {
  safeGet(() => {
    const saves = loadSaves();
    saves.splice(index, 1);
    localStorage.setItem(KEY, JSON.stringify(saves));
  }, undefined);
}
